import { Button, CircularProgress, LinearProgress, Tab, Tabs } from "@mui/material";
import QuestionnaireDetails from "./QuestionnaireDetails";
import Ajax from "../../../Ajax";
import React from "react";
import { store } from "../../../stores/Store";
import { Alert, AlertModal } from "../../..";
import QuestionnaireCopyForm from "./QuestionnaireCopyForm";
import QuestionnaireAnswers from "./QuestionnaireAnswers";
import QuestionnairePreloadedAnswers from "./QuestionnairePreloadedAnswers";
import QuestionnaireUploads from "./QuestionnaireUploads";
import { Icons } from "../../../misc/Icons";


export default function ViewQuestionnaire ({uid}) {

    const [loading, setLoading] = React.useState(false)
    const [shortlivedAccessUriIsValid, setShortlivedAccessUriIsValid] = React.useState(true)
    const [questionnaire, setQuestionnaire] = React.useState(null)
    const [tab, setTab] = React.useState("details")

    const getQuestionnaire = async () => {
        await Ajax.Questionnaire.Get(uid).then((response) => {
            setQuestionnaire(response.data)
        }).catch((response) => {
            Alert({message: response.data?.detail ? response.data.detail : "Couldn't get questionnaire"})
            store.AlertStore.Close()
        })
    }

    const toggleLock = async () => {

        var updatedQuestionnaire = {
            uid: questionnaire.uid,
            locked: !questionnaire.locked
        }

        await Ajax.Questionnaire.Update(updatedQuestionnaire).then(async () => {
            await getQuestionnaire()
        }).catch((response) => {
            Alert({message: response.data?.detail ? response.data.detail : "Couldn't update questionnaire"})
        })
    }
    
    React.useEffect(() => {
        setLoading(true)
        getQuestionnaire()
        setLoading(false)
    }, [])

    if (loading || !questionnaire) {
        return (
            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                <CircularProgress style={{width: "14px", height: "14px", margin: "0"}} />
                <p>Loading Questionnaire</p>
            </div>
        )
    }

    return (
        <div className="form">
            <div className="form-header">
                <h2>Questionnaire</h2>
                
                <Tabs value={tab} onChange={(e, value) => setTab(value)}>
                    <Tab label="Details" value="details" />
                    <Tab label="Answers" value="answers" />
                    <Tab label="Preloaded answers" value="preloadedAnswers" />
                    <Tab label="Attachments" value="attachments" />
                </Tabs>
            </div>

            {tab === "details" ? (
                <QuestionnaireDetails questionnaire={questionnaire} editable={true} />
            ) : null}

            {tab === "answers" ? (
                <QuestionnaireAnswers questionnaire={questionnaire} />
            ) : null}

            {tab === "preloadedAnswers" ? (
                <QuestionnairePreloadedAnswers questionnaire={questionnaire} />
            ) : null}

            {tab === "attachments" ? (
                <QuestionnaireUploads questionnaire={questionnaire} />
            ) : null}

            <div className="form-buttons">
                <a 
                    href={`${questionnaire.shortlivedAccessUri}?isPrivilegedUser=true&completionRedirect=${window.location}`} 
                    className={shortlivedAccessUriIsValid ? "" : "disabled"} 
                    target="_blank" 
                    onClick={async () => {
                        setShortlivedAccessUriIsValid(false)
                        await getQuestionnaire()
                        setShortlivedAccessUriIsValid(true)
                    }}>
                    <Button
                        className="btn btn-sm" 
                        color="success"
                        disabled={!shortlivedAccessUriIsValid}
                        variant="contained">
                        <Icons.Open /> Open
                    </Button>
                </a>

                <div className="form-buttons">
                    <LockToggler questionnaire={questionnaire} onClick={() => toggleLock()} />
                    
                    {store.AppStore.checkJwtRole("sysuser") ? (
                        <Button
                            onClick={async () => await Ajax.Questionnaire.Export(questionnaire.uid)}
                            className="btn btn-sm" 
                            color="secondary"
                            variant="contained">
                            Export
                        </Button>
                    ) : null}

                    <Button
                        onClick={() => AlertModal({body: <QuestionnaireCopyForm questionnaire={questionnaire} />})}
                        className="btn btn-sm" 
                        color="secondary"
                        variant="contained">
                        Make a copy
                    </Button>

                    {store.AppStore.checkJwtRole("account_manager") ? (
                        <Delete questionnaire={questionnaire} />
                    ) : null}
                </div>
            </div>
        </div>
    )
}





function Delete ({questionnaire}) {

    const [submitting, setSubmitting] = React.useState(false)

    const confirmDelete = () => {
        AlertModal({body: (
            <div className="form">
                <div className="form-fields">
                    <h4>Are you sure you want to permanently delete this questionnaire?</h4>
                </div>

                <div className="form-buttons">
                    <Button 
                        className="btn btn-sm" 
                        variant="contained"
                        onClick={() => store.AlertStore.Close()}>
                        Cancel
                    </Button>
                    <Button  
                        className="btn btn-sm" 
                        variant="contained" 
                        color="error" 
                        onClick={async () => {
                            store.AlertStore.Close()
                            setSubmitting(true)
                            await Ajax.Questionnaire.Delete(questionnaire.uid).then(() => {
                                store.QuestionnaireStore.getQuestionnaires()
                                store.AlertStore.Close()
                            }).catch((response) => {
                                Alert({message: response.data?.detail ? response.data.detail : "Couldn't delete questionnaire"})
                            })
                            setSubmitting(false)
                    }}>
                        Confirm and delete
                    </Button>
                </div>
            </div>
        )})
    }

    return (
        <div>
            <Button 
                disabled={submitting} 
                className="btn btn-sm" 
                variant="contained" 
                color="error" 
                onClick={async (e) => {
                    confirmDelete()
                }}>
                Delete
            </Button>
        </div>
    )
}


function LockToggler ({questionnaire, onClick}) {

    const [submitting, setSubmitting] = React.useState(false)

    return (
        <Button
            className="btn btn-sm"
            variant="contained" 
            disabled={submitting}
            color="secondary"
            onClick={async (e) => {
                setSubmitting(true)
                await onClick()
                setSubmitting(false)
            }}>
            {questionnaire.locked ? "Unlock" : "Lock"}
        </Button>
    )
}